import { render, staticRenderFns } from "./clientSwitch.vue?vue&type=template&id=1075ee9e"
import script from "./clientSwitch.vue?vue&type=script&lang=js"
export * from "./clientSwitch.vue?vue&type=script&lang=js"
import style0 from "./clientSwitch.vue?vue&type=style&index=0&id=1075ee9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports